import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { StorageNode, StorageNodeAssignment } from './storage-node'

export class StorageNodeFilter {
  public static readonly PARENT = 'parent'
  public static readonly PARENT_PATH = 'parentPath'

  public static parent(parent: string): Filter {
    return new Filter(StorageNodeFilter.PARENT, parent)
  }

  public static parentPath(parentPath: string[]): Filter {
    return new Filter(StorageNodeFilter.PARENT_PATH, parentPath)
  }
}

@Injectable({
  providedIn: 'root',
})
export class StorageNodeService extends RestClientPaged<StorageNode, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/storage/nodes', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findOne(path: string): Observable<StorageNode> {
    const params = HttpParamsBuilder.start().append('path', path).build()

    return this.http.get<StorageNode>(this.restEndpoint + '/one', { params: params })
  }

  public loadAssignment(nodeId: string, deepSearch: boolean): Observable<StorageNodeAssignment> {
    const params = HttpParamsBuilder.start()
      .append('deepSearch', deepSearch + '')
      .build()

    return this.http.get<StorageNodeAssignment>(this.getEntityUrl(nodeId) + '/assignment', {
      params: params,
    })
  }
}
